import moment from 'moment-timezone';

type Props = {
	locale: string;
	timezone: string;
	date?: string | Date;
};

const getStartOfDay = ({ date, locale, timezone }: Props) =>
	moment.utc(moment(date).locale(locale).tz(timezone).format('YYYY-MM-DDTHH:mm:ss')).startOf('day');

export default getStartOfDay;
